var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "lh-1" }, [
    _c("div", { staticClass: "flex f14 bg-white" }, [
      _vm.goodsVisible
        ? _c(
            "div",
            { staticClass: "flex justify-center items-center goods" },
            [_c("goodsInfo", { attrs: { detail: _vm.detail } })],
            1
          )
        : _vm._e(),
      _c(
        "div",
        {
          staticClass: "flex-auto",
          class: { pad30: _vm.type == "goods", pad20: _vm.type == "user" }
        },
        [
          _vm.type == "goods"
            ? _c(
                "div",
                { staticClass: "flex mar15-b" },
                [
                  _c("div", { staticClass: "gray3 f14 mar40-r" }, [
                    _vm._v("货品评价")
                  ]),
                  _c("el-rate", {
                    staticClass: "relative rate",
                    attrs: {
                      "void-icon-class": "el-icon-star-on",
                      "text-color": "#999",
                      "void-color": "#d9d9d9",
                      "disabled-void-color": "#d9d9d9",
                      "show-text": "",
                      disabled: "",
                      value: _vm.detail.goodsExponent,
                      texts: _vm.texts,
                      colors: _vm.colors
                    }
                  })
                ],
                1
              )
            : _vm._e(),
          _vm.type == "user"
            ? _c(
                "div",
                { staticClass: "flex items-center justify-between mar15-b" },
                [
                  _c("div", { staticClass: "flex flex-auto" }, [
                    _c("div", { staticClass: "radius100 mar10-r buyer-img" }, [
                      _c("img", {
                        staticClass: "wh68 flex-shrink radius100",
                        attrs: {
                          src: _vm.detail.buyerImg + "?imageView2/1/w/38/h/38"
                        }
                      })
                    ]),
                    _c("div", [
                      _c("div", { staticClass: "f14 mar10 fb gray3" }, [
                        _vm._v(_vm._s(_vm.detail.buyerNameEnc))
                      ]),
                      _c("div", { staticClass: "f12 gray9" }, [
                        _vm._v(_vm._s(_vm.detail.skuSpecsIndex))
                      ])
                    ])
                  ]),
                  _c("el-rate", {
                    attrs: {
                      "void-icon-class": "el-icon-star-on",
                      "text-color": "#999",
                      "void-color": "#d9d9d9",
                      "disabled-void-color": "#d9d9d9",
                      "show-text": "",
                      disabled: "",
                      value: _vm.detail.goodsExponent,
                      texts: _vm.texts,
                      colors: _vm.colors
                    }
                  })
                ],
                1
              )
            : _vm._e(),
          _c("div", { staticClass: "mar10-b lh18" }, [
            _vm._v(
              _vm._s(
                _vm.detail.evaluateSkuData && _vm.detail.evaluateSkuData.cmtBody
              )
            )
          ]),
          _c("upload", {
            attrs: { list: _vm.detail.evaluateSkuData.imgList, disabled: "" }
          }),
          _c("div", { staticClass: "f12 gray9 pad10-t" }, [
            _vm._v(
              _vm._s(
                _vm.detail.evaluateSkuData && _vm.detail.evaluateSkuData.cmtDate
              )
            )
          ]),
          _vm.detail.evaluateSkuData &&
          _vm.detail.evaluateSkuData.sellerReplyList
            ? _vm._l(_vm.detail.evaluateSkuData.sellerReplyList, function(
                reItme
              ) {
                return _c(
                  "div",
                  {
                    key: reItme.id,
                    staticClass: "bg-f7 radius4 pad15-t mar10-t pad10"
                  },
                  [
                    _c("div", { staticClass: "gray81 lh18" }, [
                      _vm._v("卖家回复：" + _vm._s(reItme.cmtBody))
                    ]),
                    _c("div", { staticClass: "gray9 f12 mar5-t" }, [
                      _vm._v(_vm._s(reItme.cmtDate))
                    ])
                  ]
                )
              })
            : _vm._e(),
          _c("div", { staticClass: "pad5" }),
          _vm._l(_vm.detail.evaluateSkuData.replyList, function(reItem) {
            return [
              _c("div", { key: reItem.id, staticClass: "mar10-t gray3 lh18" }, [
                _c("span", { staticClass: "pad5-r red" }, [_vm._v("追评")]),
                _vm._v("\n          " + _vm._s(reItem.cmtBody) + "\n        ")
              ]),
              reItem.imgList && reItem.imgList.length
                ? _c("upload", {
                    key: "a" + reItem.id,
                    staticClass: "mar10-t",
                    attrs: { list: reItem.imgList, disabled: "" }
                  })
                : _vm._e(),
              _c(
                "div",
                { key: "b" + reItem.id, staticClass: "f12 gray9 pad10-tb" },
                [_vm._v(_vm._s(reItem.cmtDate))]
              )
            ]
          }),
          _vm.detail.evaluateSkuData && _vm.orderId
            ? _c(
                "router-link",
                {
                  staticClass: "pad30-t flex justify-end",
                  attrs: {
                    to:
                      "/comment/add?orderId=" +
                      _vm.orderId +
                      "&goodsId=" +
                      _vm.detail.goodsId +
                      "&commentId=" +
                      _vm.detail.evaluateSkuData.id
                  }
                },
                [
                  _c("div", { staticClass: "white text-center pointer btn" }, [
                    _vm._v("追评")
                  ])
                ]
              )
            : _vm._e()
        ],
        2
      )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }